// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'

Vue.prototype.$http= axios
// axios.defaults.baseURL="http://localhost:44923";
Vue.config.productionTip = false


// 定义全局变量
Vue.prototype.$globalData = {
  haveToolBox: false,
  isInit: false,
}

// 定义全局函数
Vue.prototype.$CheckToolBox = function(call)
{
  if(this.$globalData.isInit) call(this.$globalData.haveToolBox);

  var that = this;
  //tool://open/?name=EasyIcon&path=EasyIcon.MainForm
  //this.$http.get('http://127.0.0.1:59786', {params:{param1: "have", param2: "p2"}})
  // this.$http.get('/local/?param1=have')
  
  this.$http.get('http://127.0.0.1:59786/?param1=have')
  .then((response)=>{
    // console.log(response);
    //ToolBox响应信息： param1=have

    if(response.status == 200 && response.data.indexOf("ToolBox响应") >= 0)
    {
      this.$globalData.haveToolBox = true;
      //console.log("存在ToolBox");
    }
    else 
    {
      this.$globalData.haveToolBox = false;
    }

    this.$globalData.isInit = true;
    if(call != null) call(this.$globalData.haveToolBox);
  })
  .catch((response)=>{
    this.$globalData.haveToolBox = false;
    this.$globalData.isInit = true;

    //console.log(response);
    if(call != null) call(false);
  })
}


/* eslint-disable no-new */
new Vue({
  el: '#app0',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js